<template>
  <Expandable header="Details" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <radio-group
          v-model="form.patient_nationlity"
          label="Recipient Nationality"
          :options="masterNationality"
          @input="onInput"
          :disabled="isAadharVerified || isDisabled"
          rules="required"
        ></radio-group>
      </b-col>
      <template v-if="isIndian">
        <b-col cols="12" md="4">
          <input-group
            label="Aadhar ID"
            :disabled="isAadharVerified || isDisabled"
            type="text"
            name="aadhar_number"
            @input="onInput"
            rules="required|aadhar|dec-0"
            v-model="form.aadhar_number"
          ></input-group>
          <div class="d-flex flex-wrap mt-1" style="gap: 6px">
            <!-- <verify-aadhar-otp
              v-if="!isAadharVerified"
              :number="form.aadhar_number"
            ></verify-aadhar-otp> -->
            <verify-a-b-d-m
              v-if="!isDisabled"
              :aadhaarNumber="form.aadhar_number"
              :isAadharVerified="isAadharVerified"
              :beneficiaryName="form.first_name"
              :phoneNumber="form.phone_number_1"
              @onAbhaVerified="onAbhaVerified"
            ></verify-a-b-d-m>
          </div>
        </b-col>
        <!-- ABDM - ABHA Integration -->
        <b-col cols="12" md="4">
          <input-group
            v-model.trim="form.abha_number"
            label="ABHA Number"
            :disabled="true"
            @input="onInput"
          ></input-group>
          <b-alert
            v-if="form.abha_verified"
            show
            variant="success"
            class="mt-1 py-1 px-2"
          >
            <small>
              <strong>ABHA Verified</strong>
              <span v-if="form.abha_address"> - {{ form.abha_address }}</span>
            </small>
          </b-alert>
        </b-col>
      </template>
      <template v-else>
        <b-col cols="12" md="4">
          <input-field
            v-model.trim="form.passport"
            :disabled="isDisabled"
            label="Passport"
            @input="onInput"
            rules="required|max-100"
          ></input-field>
        </b-col>
        <b-col cols="12" md="4">
          <file-input-group
            v-model="form.passport_document"
            label="Passport Document"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="required|file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
        <!-- Phase 2 - NRI Document Fields (US-004) -->
        <b-col cols="12" md="4">
          <file-input-group
            v-model="form.visa_document"
            label="Visa Document"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="required|file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
        <b-col cols="12" md="4">
          <input-field
            v-model.trim="form.visa_number"
            label="Visa Number"
            :disabled="isDisabled"
            @input="onInput"
            rules="required|max-50"
          ></input-field>
        </b-col>
        <b-col cols="12" md="4">
          <autocomplete
            v-model="form.visa_type"
            label="Visa Type"
            :items="nriVisaTypes"
            :disabled="isDisabled"
            @input="onInput"
            rules="required"
          ></autocomplete>
        </b-col>
        <b-col cols="12" md="4">
          <date-picker
            v-model="form.visa_expiry_date"
            label="Visa Expiry Date"
            :disabled="isDisabled"
            @input="onInput"
            rules="required"
          ></date-picker>
        </b-col>
        <b-col cols="12" md="4">
          <file-input-group
            v-model="form.national_id_document"
            label="National ID Document"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
        <b-col cols="12" md="4">
          <file-input-group
            v-model="form.embassy_clearance_document"
            label="Embassy Clearance Document"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="required|file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
      </template>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.first_name"
          label="Recipient Name"
          :disabled="isAadharVerified || form.abha_locked_fields || isDisabled"
          @input="onInput"
          rules="required|max-100"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <date-picker
          v-model="form.DOB"
          :disabled="isAadharVerified || form.abha_locked_fields || isDisabled"
          label="Recipient Date of Birth"
          @input="onInput"
          outlined
          :max="new Date()"
          rules="required"
        ></date-picker>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model="form.age"
          label="Recipient Age"
          @input="onInput"
          :disabled="true"
          type="number"
          outlined
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <select-field
          v-model="form.gender"
          label="Gender"
          @input="onInput"
          rules="required"
          :items="genders"
          :disabled="isAadharVerified || form.abha_locked_fields || isDisabled"
          outlined
        ></select-field>
      </b-col>
      <b-col cols="12" md="4">
        <phone-field
          v-model.trim="form.phone_number_1"
          :defaultCountry="form.country_code_1"
          label="Phone Number"
          @input="onInput"
          :disabled="isDisabled"
          @onCountryCode="form.country_code_1 = $event"
          rules="required|integer"
        ></phone-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          @input="onInput"
          v-model.trim="form.email_id"
          label="Email"
          :disabled="isDisabled"
          invalid="Enter a valid email address"
          rules="email"
        ></input-field>
      </b-col>
      <!-- <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.last_name"
          label="Recipient Last Name"
          @input="onInput"
          rules="max-100"
        ></input-field>
      </b-col> -->
      <b-col cols="12" md="4">
        <select-field
          @input="onInput"
          label="Blood Group"
          :disabled="isDisabled"
          :items="bloodGroups"
          v-model="form.blood_group"
          rules="required"
        ></select-field>
      </b-col>
      <template v-if="isIndian">
        <!-- Phase 2 - CM Insurance hidden (Change 5) -->
        <b-col cols="12" md="4" v-if="false">
          <select-field
            @input="onInput"
            label="CM Insurance"
            :items="masterCMInsurance"
            :disabled="isDisabled"
            v-model="form.CM_insurance"
            rules="required"
          ></select-field>
        </b-col>
        <b-col cols="12" md="4" v-if="false">
          <file-input-group
            v-model.trim="form.CM_insurance_notes"
            label="Insurance Document"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="required|file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
        <!-- Phase 2 - Below Poverty Line (BPL) Status -->
        <b-col cols="12" md="4">
          <select-field
            @input="onInput"
            label="Below Poverty Line (BPL)"
            :items="bplOptions"
            :disabled="isDisabled"
            v-model="form.bpl_status"
            rules="required"
          ></select-field>
        </b-col>
        <b-col cols="12" md="4" v-if="form.bpl_status == 1">
          <input-field
            v-model.trim="form.bpl_card_number"
            label="BPL Card Number"
            :disabled="isDisabled"
            @input="onInput"
            rules="required|max-100"
          >
            <template v-slot:help>
              <help
                text="Kutumba BPL Card Number issued by Government of Karnataka"
              ></help>
            </template>
          </input-field>
          <b-button
            v-if="!isDisabled && form.bpl_card_number"
            size="sm"
            variant="primary"
            :disabled="verifyingBPL"
            @click="verifyBPLWithKutumba"
            class="mt-1"
          >
            <b-spinner small v-if="verifyingBPL" class="mr-1"></b-spinner>
            {{ verifyingBPL ? "Verifying..." : "Verify with Kutumba" }}
          </b-button>
          <b-alert
            v-if="bplVerificationStatus"
            show
            :variant="bplVerificationStatus.is_verified ? 'success' : 'danger'"
            class="mt-2 py-1 px-2"
          >
            <small>
              <strong>{{ bplVerificationStatus.status }}:</strong>
              {{ bplVerificationStatus.msg }}
              <span v-if="bplVerificationStatus.card_holder_name">
                - {{ bplVerificationStatus.card_holder_name }}
              </span>
            </small>
            <div v-if="bplVerificationStatus.members && bplVerificationStatus.members.length" class="mt-1">
              <small><strong>Family Members:</strong></small>
              <b-table-simple small bordered class="mt-1 mb-0" style="font-size: 0.8rem;">
                <b-thead>
                  <b-tr>
                    <b-th>Name</b-th>
                    <b-th>DOB</b-th>
                    <b-th>Gender</b-th>
                    <b-th>Relation</b-th>
                    <b-th>RC Type</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(m, idx) in bplVerificationStatus.members" :key="idx">
                    <b-td>{{ m.MEMBER_NAME_ENG || m.MEMBER_NAME_KAN || '-' }}</b-td>
                    <b-td>{{ m.MBR_DOB || '-' }}</b-td>
                    <b-td>{{ m.MBR_GENDER || '-' }}</b-td>
                    <b-td>{{ m.RELATION_NAME || '-' }}</b-td>
                    <b-td>{{ m.RC_TYPE || '-' }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </b-alert>
        </b-col>
        <b-col cols="12" md="4" v-if="form.bpl_status == 1">
          <file-input-group
            v-model.trim="form.bpl_document"
            label="BPL Proof Document"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="required|file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
      </template>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.notto_id"
          label="NOTTO Registration No"
          @input="onInput"
          :disabled="isDisabled"
          rules="required|max-50"
        >
        </input-field>
      </b-col>
      <!-- Phase 2 - Emergency Status for Heart/Liver/Lung (Change 17) -->
      <b-col cols="12" md="4">
        <select-field
          v-model="form.emergency_status"
          label="Emergency Status"
          :items="emergencyStatusOptions"
          :disabled="isDisabled"
          @input="onInput"
          rules=""
        ></select-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.payment_reference_no"
          label="Payment Reference No"
          @input="onInput"
          :disabled="true"
        >
          <!-- <template v-slot:help>
            <b-button @click="openPayment()" variant="primary"
              >Payment Link</b-button
            >
          </template> -->
        </input-field>
      </b-col>
    </b-row>
  </Expandable>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import Expandable from "../../Expandable.vue";
import RadioGroup from "../../form/RadioGroup.vue";
import SelectField from "../../form/SelectField.vue";
import FileInputGroup from "../../form/FileInputGroup.vue";
import PhoneField from "../../form/PhoneField.vue";
import DatePicker from "../../form/DatePicker.vue";
import { getAge, PAYMENT_LINK } from "../../../assets/js/common";
import { GENDERS } from "../../../assets/constants/hospital.contants";
import { BPL_STATUS, NRI_VISA_TYPES, EMERGENCY_STATUS } from "../../../assets/constants/recipient.constants";
import VerifyAadharOtp from "./VerifyAadharOtp.vue";
import VerifyABDM from "./VerifyABDM.vue";
import Help from "../../Help.vue";
// NRIDocuments removed - fields now inline in Details.vue
import recipientService from "../../../assets/services/recipient.service";
import event from "../../../assets/js/event";

export default {
  props: {
    value: {},
    hospitalType: {},
    isAadharVerified: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Expandable,
    RadioGroup,
    SelectField,
    FileInputGroup,
    PhoneField,
    DatePicker,
    VerifyAadharOtp,
    VerifyABDM,
    Help,
  },
  data() {
    return {
      form: {},
      genders: GENDERS,
      verifyingBPL: false,
      bplVerificationStatus: null,
    };
  },
  computed: {
    isIndian() {
      return this.form.patient_nationlity == 0;
    },
    isGoverMentHospital() {
      return this.hospitalType == 1;
    },
    isCMFile() {
      let insurance = this.form.CM_insurance;
      return insurance == 1 || insurance == 3;
    },
    bplOptions() {
      return BPL_STATUS;
    },
    nriVisaTypes() {
      return NRI_VISA_TYPES;
    },
    emergencyStatusOptions() {
      return EMERGENCY_STATUS;
    },
    isExistingRecord() {
      return !!this.form.recipient_registration_id && this.form.dml_indicator === "U";
    },
    isBplVerifiedComputed() {
      if (this.form.bpl_status != "1") return true;
      // Existing records with BPL already saved don't need re-verification
      if (this.isExistingRecord) return true;
      return this.bplVerificationStatus != null && this.bplVerificationStatus.is_verified === true;
    },
  },
  watch: {
    isBplVerifiedComputed: {
      handler(val) {
        this.$emit("bpl-verified", val);
      },
      immediate: true,
    },
  },
  methods: {
    setAadharDetails(doc) {
      Object.keys(doc).forEach((key) => {
        this.form[key] = doc[key];
      });
      this.onInput();
    },
    openPayment() {
      window.open(PAYMENT_LINK, "_blank");
    },
    onInput() {
      let { DOB } = this.form;
      if (DOB) {
        this.form.age = getAge(DOB);
      }
      this.$emit("input", this.form);
    },
    onAbhaVerified(doc) {
      // ABHA fields
      this.form.abha_number = doc.abha_number || "";
      this.form.abha_address = doc.abha_address || "";
      this.form.abha_verified = true;
      // NHA M1: Lock name/DOB/gender after ABHA verification
      this.form.abha_locked_fields = !!doc.abha_locked_fields;

      // Auto-fill from ABHA profile - overwrite for locked fields (name, DOB, gender)
      if (doc.first_name) {
        this.form.first_name = doc.first_name;
      }
      if (doc.DOB) {
        this.form.DOB = doc.DOB;
      }
      if (doc.gender) {
        this.form.gender = doc.gender;
      }
      // Editable fields - only fill if empty
      if (doc.phone_number_1 && !this.form.phone_number_1) {
        this.form.phone_number_1 = doc.phone_number_1;
      }
      if (doc.email_id && !this.form.email_id) {
        this.form.email_id = doc.email_id;
      }

      // Auto-fill Aadhar Address section from ABHA profile
      if (doc.address_line || doc.pincode) {
        let address = {
          aadhar_name: doc.first_name || "",
          address_line_1: doc.address_line || "",
          pincode: doc.pincode || "",
        };
        if (doc.abha_photo) {
          address.aadhar_photo = doc.abha_photo;
        }
        event.$emit("initAadhar", {
          address,
          state: doc.state || "",
          city: doc.district || "",
        });
      }

      this.onInput();
    },
    isBplVerified() {
      return this.isBplVerifiedComputed;
    },
    async verifyBPLWithKutumba() {
      if (!this.form.bpl_card_number) return;
      this.verifyingBPL = true;
      this.bplVerificationStatus = null;
      try {
        let res = await recipientService.verifyBPLWithKutumba({
          recipient_registration_id: this.form.recipient_registration_id,
          bpl_card_number: this.form.bpl_card_number,
        });
        let data = res.data;
        this.bplVerificationStatus = {
          status: data.verification_status,
          is_verified: data.is_verified,
          msg: data.msg,
          card_holder_name: data.card_holder_name || "",
          members: data.members || [],
        };
      } catch (err) {
        this.bplVerificationStatus = {
          status: "ERROR",
          is_verified: false,
          msg: "Verification request failed. Please try again.",
          card_holder_name: "",
        };
      } finally {
        this.verifyingBPL = false;
      }
    },
  },
  beforeMount() {
    this.form = this.value;
    this.onInput();
  },
};
</script>

<style></style>
